<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'satisfaction.callModal.title' | translate }}</h3>
      <button class="btn-close" (click)="onClose()">×</button>
    </div>
    <div class="modal-body" *ngIf="feedback">
      <div class="feedback-info">
        <p><strong>{{ 'satisfaction.common.patientLabel' | translate }}</strong> {{ feedback.contact_tel || 'satisfaction.common.notProvided' | translate }}</p>
        <p><strong>{{ 'satisfaction.common.feedbackDateLabel' | translate }}</strong> {{ formatDate(feedback.created_at) }}</p>
        <p><strong>{{ 'satisfaction.common.ratingLabel' | translate }}</strong> {{ '⭐'.repeat(feedback.score || 0) }} ({{ feedback.score }}/5)</p>
      </div>

      <div class="history-section" *ngIf="feedback.comment">
        <h4>{{ 'satisfaction.common.patientCommentHeading' | translate }}</h4>
        <div class="comment-box">
          {{ feedback.comment }}
        </div>
      </div>

      <div class="message-input">
        <label for="voicemail">{{ 'satisfaction.common.voicemailContentLabel' | translate }}</label>
        <textarea
          id="voicemail"
          [(ngModel)]="voicemailContent"
          [placeholder]="'satisfaction.callModal.voicemailPlaceholder' | translate"
          rows="4"></textarea>
      </div>

      <div class="contact-confirmation">
        <label class="checkbox-label-large">
          <input type="checkbox" [(ngModel)]="patientContacted">
          <span class="checkmark-large"></span>
          {{ 'satisfaction.callModal.contactedCheckboxLabel' | translate }}
        </label>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-no-reply" (click)="onNoReply()">{{ 'satisfaction.common.closedWithoutContact' | translate }}</button>
      <div class="footer-right">
        <button class="btn-cancel" (click)="onClose()">{{ 'common.actions.cancel' | translate }}</button>
        <button class="btn-send" (click)="onMarkAsCalled()">
          {{ 'common.actions.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-confirm-modal
  *ngIf="showConfirmNoReply"
  [title]="'satisfaction.common.confirmationTitle' | translate"
  [message]="'satisfaction.common.closeWithoutReplyConfirmMessage' | translate"
  [confirmText]="'common.actions.confirm' | translate"
  [cancelText]="'common.actions.cancel' | translate"
  (confirm)="onConfirmNoReply()"
  (cancel)="onCancelNoReply()">
</app-confirm-modal>